module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-announcement"
  }, [(_vm.announcement) ? _c('div', {
    staticClass: "sd-anncmt-box"
  }, [_c('div', {
    attrs: {
      "id": "sd-anncmt-header"
    }
  }, [_c('a', {
    staticClass: "sd-anncmt-close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('span', [_vm._v("schliessen")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/material_icons/close.png",
      "width": "14px",
      "height": "14px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sd-anncmt-scrollable"
  }, [_c('div', {
    staticClass: "sd-anncmt-content",
    domProps: {
      "innerHTML": _vm._s(_vm.announcement)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d101f17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/childs/Announcement.vue
// module id = 421
// module chunks = 1